// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"65f0cb84","80":"605f7640","139":"e48bfb56","146":"e5517d83","220":"332c5405","610":"2334e589","787":"7982a17c"}[chunkId] + ".chunk.js";
};